var useNotificationsPermissions = function useNotificationsPermissions() {
  return null;
};
export default useNotificationsPermissions;